import React from "react";
import Joi from "joi-browser";
import Form from "../common/form";
import { saveSingle } from "../../services/contributerService";
import { toast } from "react-toastify";
import BlockUi from "react-block-ui";
import { Table } from "semantic-ui-react";
import TableTitle from "../common/tableTitle";
import { Link } from "react-router-dom";
import {
  CountryDropdown,
  RegionDropdown,
  CountryRegionData,
} from "react-country-region-selector";

import { getVillages } from "../../services/villageService";
import professions from "professions";

class TeacherForm extends Form {
  state = {
    imageUrl: "",
    data: {
      full_name: "",
      father_name: "",
      city: "",
      village_id: "",
      profession: "",
      education: "",
      mobile: "",
      role: "",
      profession_detail: "",
      education_detail: "",
    },
    country: "",
    region: "",
    villages: [],
    errors: {},
    professions: [],
    educations: [
      { id: "", name: "Select Education" },
      { id: "No formal Education", name: "No formal Education" },
      { id: "Primary Education", name: "Primary Education" },
      {
        id: "Secondary Education or high school",
        name: "Secondary Education or high school",
      },
      { id: "GED", name: "GED" },
      { id: "Vocational qualification", name: "Vocational qualification" },
      { id: "Bachelor's degree", name: "Bachelor's degree" },
      { id: "Master's degree", name: "Master's degree" },
      { id: "Doctorate or higher", name: "Doctorate or higher" },
    ],
    roles: [
      { id: "member", name: "Member" },
      { id: "reporter", name: "Reporter" },
      { id: "facebook", name: "Facebook" },
      { id: "special", name: "Core" },
    ],
  };

  schema = {
    id: Joi.string(),
    full_name: Joi.string().required().label("Full Name"),
    father_name: Joi.string().required().label("Father Name"),
    city: Joi.string().required().label("City"),
    village_id: Joi.allow(""),
    profession: Joi.string().required().label("Profession"),
    education: Joi.string().required().label("Eduction"),
    mobile: Joi.string().required().label("Mobile"),
    role: Joi.allow(""),
    profession_detail: Joi.allow(""),
    education_detail: Joi.allow(""),
  };

  async componentDidMount() {
    document.body.style.backgroundImage = "url('./new_theme/yard-bg.jpg')";
    this.setState({ blocking: true, show: "none" });
    const { data: villages } = await getVillages();
    const villagesList = [{ id: "", name: "Select Village" }, ...villages];

    let pros = [];
    professions.map((profession) => {
      let item = {};
      item.id = profession;
      item.name = profession;
      pros.push(item);
    });

    const proList = [
      { id: "", name: "Select Profession" },
      { id: "government", name: "Government Servant" },
      { id: "agriculture", name: "Agriculture" },
      { id: "transporter", name: "Transporter" },
      { id: "contractor", name: "Contractor" },
      ...pros,
    ];

    this.setState({
      professions: proList,
      villages: villagesList,
      blocking: false,
    });
  }

  doSubmit = async () => {
    try {
      this.setState({ blocking: true });

      let formData = new FormData();
      formData.append("full_name", this.state.data.full_name);
      formData.append("father_name", this.state.data.father_name);
      formData.append("city", this.state.data.city);
      formData.append("village", this.state.data.village_id);
      formData.append("profession", this.state.data.profession);
      formData.append("education", this.state.data.education);
      formData.append("mobile", this.state.data.mobile);

      formData.append("country", this.state.country);
      formData.append("region", this.state.region);

      formData.append("profession_detail", this.state.data.profession_detail);
      formData.append("education_detail", this.state.data.education_detail);

      formData.append("image", this.state.imageUrl);
      formData.append(
        "role",
        this.state.data.role == "" ? "member" : this.state.data.role
      );

      await saveSingle(formData);

      toast.success("Contributer has been added successfully.");
      this.setState({ blocking: false });
      this.props.history.push("/web/contributers");
    } catch (ex) {
      console.log(ex.response);
      if (ex.response && ex.response.status === 422) {
        const errors = { ...this.state.errors };

        if (ex.response.data.errors.name)
          errors.name = ex.response.data.errors.name;

        this.setState({ errors, blocking: false });
        //toast.warning("check validation errors.");
      }
    }
  };

  onChangeImage = (e) => {
    let files = e.target.files || e.dataTransfer.files;
    if (!files.length) return;
    this.setState({ imageUrl: files[0] });
    //this.createImage(files[0]);
  };

  selectCountry(val) {
    this.setState({ country: val });
  }

  selectRegion(val) {
    this.setState({ region: val });
  }

  render() {
    const dashboardIcon = process.env.REACT_APP_URL + "/new_theme/bank.png";
    const { country, region } = this.state;

    return (
      <BlockUi tag="div" blocking={this.state.blocking}>
        <TableTitle
          title="Add Contributer"
          icon="tag"
          color="white"
          iconPath={dashboardIcon}
        />
        <center>
          <form
            onSubmit={this.handleSubmit}
            className="ui error form"
            style={{ width: "70%" }}
          >
            <Table>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell colSpan="2">
                    Add Contributer
                  </Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                <Table.Row>
                  <Table.Cell width="8">
                    {this.renderInput("full_name", "Full Name", "text")}
                  </Table.Cell>
                  <Table.Cell width="8">
                    {this.renderInput("father_name", "Father Name", "text")}
                  </Table.Cell>
                </Table.Row>

                <Table.Row>
                  <Table.Cell width="8">
                    Country
                    <CountryDropdown
                      value={country}
                      onChange={(val) => this.selectCountry(val)}
                    />
                  </Table.Cell>
                  <Table.Cell width="8">
                    State
                    <RegionDropdown
                      country={country}
                      value={region}
                      onChange={(val) => this.selectRegion(val)}
                    />
                  </Table.Cell>
                </Table.Row>

                <Table.Row>
                  <Table.Cell width="8">
                    {this.renderInput("city", "City", "text")}
                  </Table.Cell>
                  <Table.Cell width="8">
                    {this.renderSelect(
                      "village_id",
                      "Village",
                      this.state.villages
                    )}
                  </Table.Cell>
                </Table.Row>

                <Table.Row>
                  <Table.Cell width="8">
                    {this.renderSelect(
                      "profession",
                      "Profession",
                      this.state.professions
                    )}
                  </Table.Cell>
                  <Table.Cell width="8">
                    {this.renderInput(
                      "profession_detail",
                      "Profession Detail",
                      "text"
                    )}
                  </Table.Cell>
                </Table.Row>

                <Table.Row>
                  <Table.Cell width="8">
                    {this.renderSelect(
                      "education",
                      "Education",
                      this.state.educations
                    )}
                  </Table.Cell>
                  <Table.Cell width="8">
                    {this.renderInput(
                      "education_detail",
                      "Education Detail",
                      "text"
                    )}
                  </Table.Cell>
                </Table.Row>

                <Table.Row>
                  <Table.Cell width="8">
                    {this.renderInput("mobile", "Mobile", "text")}
                  </Table.Cell>
                  <Table.Cell width="8">
                    <label>Picture</label>
                    <input
                      className="input_imagem_artigo"
                      type="file"
                      onChange={this.onChangeImage}
                    />
                  </Table.Cell>
                </Table.Row>

                <Table.Row>
                  <Table.Cell width="8">
                    {this.renderSelect("role", "Role", this.state.roles)}
                  </Table.Cell>
                  <Table.Cell width="8"></Table.Cell>
                </Table.Row>

                <Table.Row>
                  <Table.Cell>
                    {this.renderButton("Save")}
                    <Link
                      to="/web/contributers"
                      className="ui secondary button"
                    >
                      Back
                    </Link>
                  </Table.Cell>
                  <Table.Cell></Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table>
          </form>
        </center>
      </BlockUi>
    );
  }
}

export default TeacherForm;
